import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import { AuthProvider } from './contexts/AuthContext';

import App from './App';

import ReactGA from 'react-ga4';
import TagManager from 'react-gtm-module';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

ReactGA.initialize("G-7JPFWYHHH6");

ReactGA.send({ hitType: 'pageview', page: window.location.pathname });

// Configura los argumentos con tu ID de contenedor
const tagManagerArgs = { gtmId: 'GTM-K8PRXQQJ' };

// Inicializa Tag Manager
TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <AuthProvider>
            <App />
        </AuthProvider>
    </React.StrictMode>
);
